/**
 * Case 2's chart — GENERATED, do not hand-edit.
 *
 * Produced by ~/march-case2-data/build-case2-chart.py from what the live dev
 * system returned for this patient. Re-run it after a fresh capture.
 */

/* eslint-disable */
export interface ChartCondition {
  title: string;
  code: string;
  /** Not captured: onsets appear only in narrative prose, and a parsed date
   *  rendered on a timeline would read as a recorded one. */
  onset: string | null;
  status: string;
  resolved: string | null;
}

/** REAL: the active problem list, from the twin's own condition families. */
export const CHART_CONDITIONS: ChartCondition[] = [
  { title: "Body mass index 30+ - obesity", code: 'SNOMED 162864005', onset: null, status: 'active', resolved: null },
  { title: "Chronic intractable migraine without aura", code: 'SNOMED 124171000119105', onset: null, status: 'active', resolved: null },
  { title: "Chronic kidney disease stage 3A", code: 'SNOMED 700378005', onset: null, status: 'active', resolved: null },
  { title: "Chronic pain", code: 'SNOMED 82423001', onset: null, status: 'active', resolved: null },
  { title: "Chronic viral hepatitis C", code: 'SNOMED 128302006', onset: null, status: 'active', resolved: null },
  { title: "Dependent drug abuse", code: 'SNOMED 6525002', onset: null, status: 'active', resolved: null },
  { title: "Impacted molars", code: 'SNOMED 196416002', onset: null, status: 'active', resolved: null },
  { title: "Peripartum cardiomyopathy", code: 'SNOMED 85898001', onset: null, status: 'active', resolved: null },
  { title: "Preeclampsia", code: 'SNOMED 398254007', onset: null, status: 'active', resolved: null },
  { title: "Pulmonary emphysema", code: 'SNOMED 87433001', onset: null, status: 'active', resolved: null },
];

/** REAL: 43 dated systolic readings, from the BP answer's own table */
export const SYSTOLIC_SERIES: Array<{ date: string; value: number }> = [
  { date: '1987-10-02', value: 94 },
  { date: '1987-11-06', value: 96 },
  { date: '1988-01-08', value: 96 },
  { date: '1988-03-11', value: 95 },
  { date: '1988-06-10', value: 96 },
  { date: '1988-09-09', value: 96 },
  { date: '1988-12-09', value: 96 },
  { date: '1989-03-10', value: 93 },
  { date: '1989-09-08', value: 93 },
  { date: '1990-03-09', value: 94 },
  { date: '1990-09-07', value: 102 },
  { date: '1991-03-08', value: 94 },
  { date: '1991-09-06', value: 94 },
  { date: '1992-09-11', value: 90 },
  { date: '1993-09-17', value: 95 },
  { date: '1994-09-23', value: 94 },
  { date: '1995-09-29', value: 97 },
  { date: '1996-10-04', value: 101 },
  { date: '1997-10-10', value: 95 },
  { date: '1998-10-16', value: 93 },
  { date: '1999-10-22', value: 97 },
  { date: '2000-03-10', value: 93 },
  { date: '2000-10-27', value: 90 },
  { date: '2001-11-02', value: 101 },
  { date: '2002-11-08', value: 86 },
  { date: '2003-11-14', value: 99 },
  { date: '2004-11-19', value: 93 },
  { date: '2005-11-25', value: 98 },
  { date: '2006-12-01', value: 99 },
  { date: '2009-12-04', value: 100 },
  { date: '2010-03-26', value: 88 },
  { date: '2012-04-06', value: 99 },
  { date: '2012-12-07', value: 94 },
  { date: '2015-12-11', value: 100 },
  { date: '2016-04-15', value: 95 },
  { date: '2018-12-14', value: 99 },
  { date: '2019-02-01', value: 89 },
  { date: '2021-12-17', value: 101 },
  { date: '2023-09-15', value: 142 },
  { date: '2023-09-29', value: 146 },
  { date: '2023-10-06', value: 151 },
  { date: '2023-11-24', value: 148 },
  { date: '2024-12-20', value: 93 },
];

/** REAL: 43 dated diastolic readings, from the BP answer's own table */
export const DIASTOLIC_SERIES: Array<{ date: string; value: number }> = [
  { date: '1987-10-02', value: 68 },
  { date: '1987-11-06', value: 66 },
  { date: '1988-01-08', value: 66 },
  { date: '1988-03-11', value: 67 },
  { date: '1988-06-10', value: 69 },
  { date: '1988-09-09', value: 70 },
  { date: '1988-12-09', value: 62 },
  { date: '1989-03-10', value: 63 },
  { date: '1989-09-08', value: 69 },
  { date: '1990-03-09', value: 63 },
  { date: '1990-09-07', value: 67 },
  { date: '1991-03-08', value: 70 },
  { date: '1991-09-06', value: 70 },
  { date: '1992-09-11', value: 70 },
  { date: '1993-09-17', value: 68 },
  { date: '1994-09-23', value: 70 },
  { date: '1995-09-29', value: 64 },
  { date: '1996-10-04', value: 67 },
  { date: '1997-10-10', value: 70 },
  { date: '1998-10-16', value: 68 },
  { date: '1999-10-22', value: 66 },
  { date: '2000-03-10', value: 65 },
  { date: '2000-10-27', value: 68 },
  { date: '2001-11-02', value: 68 },
  { date: '2002-11-08', value: 67 },
  { date: '2003-11-14', value: 65 },
  { date: '2004-11-19', value: 68 },
  { date: '2005-11-25', value: 63 },
  { date: '2006-12-01', value: 60 },
  { date: '2009-12-04', value: 70 },
  { date: '2010-03-26', value: 68 },
  { date: '2012-04-06', value: 70 },
  { date: '2012-12-07', value: 64 },
  { date: '2015-12-11', value: 68 },
  { date: '2016-04-15', value: 70 },
  { date: '2018-12-14', value: 64 },
  { date: '2019-02-01', value: 62 },
  { date: '2021-12-17', value: 67 },
  { date: '2023-09-15', value: 92 },
  { date: '2023-09-29', value: 94 },
  { date: '2023-10-06', value: 97 },
  { date: '2023-11-24', value: 96 },
  { date: '2024-12-20', value: 70 },
];
